import { Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { createBrowserHistory } from 'history';
import FineTicket from 'pages/mobile/car/FineTicket';
import ParkingFee from 'pages/mobile/car/ParkingFee';
import ETag from 'pages/mobile/car/ETag';
import Maintenance from 'pages/mobile/car/Maintenance';
import Inspection from 'pages/mobile/car/Inspection';
import Appointment from 'pages/mobile/car/Appointment';
import ConsultantInfo from 'pages/mobile/car/ConsultantInfo';
import SalesInfo from 'pages/mobile/car/SalesInfo';
import liff from '@line/liff';
import secureStorage from '../../shared/secureStorage';

const CarInfoRouter = () => {
  const history = createBrowserHistory();
  const navigate = useNavigate();
  useEffect(() => {
    // 在組件掛載時添加監聽器
    const unlisten = history.listen((location) => {
      if (location.action === 'POP') {
        if (secureStorage.getItem('oneCarRedirect') === 'true') {
          // 關閉Liff
          liff.closeWindow();
        } else {
          // 返回到車輛列表
          navigate('/m/Car/CarList');
        }
      }
    });

    // 在組件卸載時移除監聽器
    return () => {
      unlisten();
    };
  }, []);
  return (
    <Routes>
      <Route path="/FineTicket" element={<FineTicket />}></Route>
      <Route path="/ParkingFee" element={<ParkingFee />}></Route>
      <Route path="/ETag" element={<ETag />}></Route>
      <Route path="/Maintenance" element={<Maintenance />}></Route>
      <Route path="/Inspection" element={<Inspection />}></Route>
      <Route path="/Appointment" element={<Appointment />}></Route>
      <Route path="/ConsultantInfo" element={<ConsultantInfo />}></Route>
      <Route path="/SalesInfo" element={<SalesInfo />}></Route>
    </Routes>
  );
};

export default CarInfoRouter;
